<template>
  <div
    class="under-menu-component"
    :class="[isMobile() ? 'mobile-under-menu-component' : '']"
    :style="transformCoef"
  >
    <div class="component-item" />
  </div>
</template>

<script lang="ts">
// External Package codes
import { WindowAspect } from '@powerplay/core-minigames-ui-ssm'

// Game Components

import { defineComponent } from 'vue'
import { wind } from '@/app/entities/athlete/Wind'
import { uiState } from '@/stores'

export default defineComponent({
  name: 'UnderMenuComponent',
  mixins: [WindowAspect],
  data() {

    return {
      uiState: uiState()
    }

  },
  computed: {
    transformCoef() {

      return {
        transform: `scale(${this.scaleCoef})`,
        'transform-origin': '100% 0'
      }

    },
    getWindText() {

      return `${wind.getValueWithSignAsString()} m/s`

    }
  },
})

</script>

<style lang="less" scoped>

.under-menu-component{
    position: absolute;
    right: 1%;
    top: 14%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    &.mobile-under-menu-component {
        top: 14%;
    }

    .component-item {
        position: relative;
        margin-bottom: 15px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 20px;
    }

}

</style>
